import primaryButtonDisabled from '../../../../../common/algorithms/primary-button-disabled';

const secondary = (params) => primaryButtonDisabled(params);

export default secondary;
